// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__3Y22f","productName":"Table_productName__1Y9_n"};